import * as React from 'react';
export const IcLocationHospital = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14 7a1 1 0 00-1 1v1h-2V8a1 1 0 00-2 0v4a1 1 0 102 0v-1h2v1a1 1 0 002 0V8a1 1 0 00-1-1zm3.57-2.92A7.79 7.79 0 0012 1.93a7.82 7.82 0 00-8 7.6c0 5.08 5.91 11.14 6.59 11.81a2 2 0 002.82 0c.68-.67 6.59-6.73 6.59-11.81a7.81 7.81 0 00-2.43-5.45zM12 15.86a5.93 5.93 0 01-1.16-11.75 6 6 0 013.43.34A5.93 5.93 0 0112 15.86z'
      fill='currentColor'
    />
  </svg>
);
